module.exports = __webpack_public_path__ + "img/help.cacd4029.svg";